import { render, staticRenderFns } from "./Reguser.vue?vue&type=template&id=97160600&scoped=true"
import script from "./Reguser.vue?vue&type=script&lang=js"
export * from "./Reguser.vue?vue&type=script&lang=js"
import style0 from "./Reguser.vue?vue&type=style&index=0&id=97160600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97160600",
  null
  
)

export default component.exports